export enum EscrowOnboardingNewRoutesEnum {
  Access = 'access',
}
